export enum Pages {
  HOME = "home",
  ABOUT = "about",
  CONTACT = "contact",
  ANKIETA = "ankieta",
  MORE = "MORE",
}
